import React from "react";
import Body from "components/design-system/atoms/Typography/Body";
import { getClientLocalCatalogs } from "../../../components/localOfferEligibility/LocalOfferEligibility";
import { useTheme, useMediaQuery } from "@material-ui/core";

export default function HitsNumber({ searchResults }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const localCatalogCount = React.useMemo(
    () =>
      getClientLocalCatalogs()?.length &&
      searchResults?.disjunctiveFacets.find((item) => item.name === "catalogs.slug")?.data[getClientLocalCatalogs()[0]],
    [searchResults]
  );

  const pluralize = (text, number) => {
    return number > 1 ? text + "s" : text;
  };

  const getText = () => {
    let text = "";
    if (isMobile) {
      text = `${searchResults.nbHits} ${pluralize("résultat", searchResults.nbHits)}`;
    } else {
      text = ` - ${searchResults.nbHits} ${pluralize("résultat", searchResults.nbHits)}`;
    }
    if (localCatalogCount) {
      text += ` dont ${localCatalogCount} dans votre région`;
    }
    return text;
  };

  if (!searchResults) {
    return null;
  }

  return <Body color="text.disabled">{getText()}</Body>;
}
